import { Box, Container, Grid } from "@mui/material";
import WorkDiary from "../components/workDiary/WorkDiary";
import PageTitle from "../../components/pageTitle/PageTitle";
import ManageTask from "../components/workDiary/ManageTask";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CompleteWorkDiary from "../components/workDiary/CompleteWorkDiary";
import NoPermissionPage from "../../components/common/NoPermissionPage";

const ClientAdminWorkDiary = () => {
  const { userProfile, workDiaryModulePermission } = useSelector(
    (state: any) => state?.user
  );
  const [isBasicDiarySection, setIsBasicDiarySection] = useState(
    userProfile?.features?.includes("Basic Work Diary") || false // Safe fallback
  );

  useEffect(() => {
    setIsBasicDiarySection(
      userProfile?.features?.includes("Basic Work Diary") || false
    ); // Sync profile changes
  }, [userProfile]);

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleTask = () => {
    setOpen(true);
  };
  return (
    <>
      {open && (
        <ManageTask open={open} onHide={handleClose} title="SCHEDULE A TASK" />
      )}
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{
          background: "#f4f4f4",
          paddingTop: "16px",
        }}
      >
        <Grid item xs={12} md={12}>
          <Container
            sx={{
              bgcolor: "#fff",
              padding: "16px !important",
              borderRadius: "10px",
              maxWidth: "100% !important",
            }}
          >
            <PageTitle
              title="Work Diary"
              button={
                userProfile?.roles?.includes("Owner") ||
                userProfile?.roles?.includes("TENANT") ||
                workDiaryModulePermission?.create
                  ? "Add Task"
                  : ""
              }
              onClick={handleTask}
            />
            {userProfile?.roles?.includes("Owner") ||
            userProfile?.roles?.includes("TENANT") ||
            workDiaryModulePermission?.read ? (
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto", sm: "100vh" },
                  border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  padding: "4px 16px",
                  overflowY: "scroll",
                }}
              >
                {isBasicDiarySection ? <WorkDiary /> : <CompleteWorkDiary />}
              </Box>
            ) : (
              <>
                <NoPermissionPage />
              </>
            )}
          </Container>
        </Grid>
      </Grid>
    </>
  );
};
export default ClientAdminWorkDiary;
